export const DOC_CODE = "documentCode";
export const DOC_NAME = "documentName";
export const DESCRIPTION = "description";
export const IS_REQUIRED = "requirementType";
export const DISPLAY_ORDER = "displayOrder";
export const FILE_TYPES = "allowedFileTypes";
export const OCP_STAGE = "ocpStage";
export const MAX_FILE_SIZE = "maxFileSizeMb"; // in mb
export const STATUS = "active";
export const COMMUNITY_ID = "communityId";